import { render, staticRenderFns } from "./AssistantLocation.vue?vue&type=template&id=c53403a4&scoped=true"
import script from "./AssistantLocation.vue?vue&type=script&lang=js"
export * from "./AssistantLocation.vue?vue&type=script&lang=js"
import style0 from "./AssistantLocation.vue?vue&type=style&index=0&id=c53403a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c53403a4",
  null
  
)

export default component.exports